module.exports = __webpack_public_path__ + "img/about.76e56e1a.svg";